import { Controller } from "@hotwired/stimulus"

// Tick boxes in a list, act on what is ticked. One box in the table head
// selects every row; the bar with the count and the button only shows while
// something is selected, so a list nobody is deleting from looks as it did.
//
// The confirm text is written into the form at every change rather than once
// in the markup, because it names the number: "Slet 12 valgte aktiviteter?"
export default class extends Controller {
  static targets = ["all", "item", "count", "form"]
  static values  = { confirm: String }

  connect() {
    this.refresh()
  }

  toggleAll() {
    this.itemTargets.forEach(item => { item.checked = this.allTarget.checked })
    this.refresh()
  }

  refresh() {
    this.itemTargets.forEach(item => item.closest("tr")?.classList.toggle("is-selected", item.checked))

    const selected = this.itemTargets.filter(item => item.checked).length
    const total    = this.itemTargets.length

    if (this.hasAllTarget) {
      this.allTarget.checked       = total > 0 && selected === total
      this.allTarget.indeterminate = selected > 0 && selected < total
    }

    this.formTarget.hidden = selected === 0
    this.countTarget.textContent = selected === 1 ? "1 valgt" : `${selected} valgt`
    this.formTarget.dataset.turboConfirm = this.confirmValue.replace("%{count}", this.noun(selected))
  }

  noun(count) {
    return count === 1 ? "1 valgt aktivitet" : `${count} valgte aktiviteter`
  }
}
